import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  CloseButton,
  Dropdown,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { PageHeader, Pagination } from '../../components';
import PickerDetailsGetModal from '../../components/Modals/PickerDetailsGetModal.jsx';
import CheckableDataTable from '../../components/CheckableDataTable/CheckableDataTable';
import useComponentState from '../../utils/useComponentState';
import { getDeliveryOrders, updateStatus } from '../../api/Orders';
import { Drawer } from 'rsuite';
import Search from '../../components/Search/Search.component';
import InputGroup from 'react-bootstrap/InputGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import styles from './ViewOrders.module.scss';
import { copyToClipboard } from '../../utils/helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faSpinner } from '@fortawesome/free-solid-svg-icons';
import DatePickerModal from '../../components/Modals/DatePickerModal';
import { toast } from 'react-toastify';
import { APP_PARAMS } from '../../constants/appParams';
import { useGetQueryParams } from '../../hooks/useGetQueryParams';
import { useSetQueryParams } from '../../hooks/useSetQueryParams';
import Modal from 'react-bootstrap/Modal';
import { printZPL } from '../../utils/printerUtils';
import DeliveryDetailsPrintModal from '../../components/Modals/DeliveryDetailsPrintModal.jsx';
import connectPrinter from '../../utils/connectPrinter';
import { getCarrierBook, getQrPdf } from '../../api/Vouchers.js';
import { DATE_TIME_TYPES } from '../../constants/dataTimeTypes.js';
import FileSaver from 'file-saver';
import { formatDateTime } from '../../utils/dataFormatter.js';
import { generateAndSavePdf } from '../ViewVouchers/ViewVouchersUtils.js';
import NameLabelModal from '../../components/Modals/NameLabelModal.jsx';

const ViewOrders = (props) => {
  const queryParams = useGetQueryParams([
    APP_PARAMS.PAGE,
    APP_PARAMS.DELIVERY_TYPE,
    APP_PARAMS.DELIVERY_STATUS,
    APP_PARAMS.SEARCH_KEY,
    APP_PARAMS.SELECTED,
  ]);
  const setQueryParam = useSetQueryParams();

  const [state, setState] = useComponentState({
    tableHeading: {
      column: [
        'Purchase ID',
        'Created Date',
        'Deliver On/Before',
        'Voucher ID',
        'Receiver',
        'Dispatch',
        'Same Day',
        'Status',
        '',
      ],
    },
    showDeliveryModal: false,
    orderData: [],
    tabItems: {
      orderType: [
        { key: null, label: 'ALL TYPES' },
        { key: 'COURIER_DELIVERY', label: 'DELIVERY' },
        { key: 'STORE_PICKUP', label: 'PICKUP' },
      ],
      orderStatus: [
        { key: null, label: 'ALL STATUSES' },
        { key: 'PROCESSING', label: 'PROCESSING' },
        { key: 'PICKUP_READY', label: 'PICKUP READY' },
        { key: 'PICKED', label: 'PICKED' },
        { key: 'DISPATCHED', label: 'DISPATCHED' },
        { key: 'DELIVERED', label: 'DELIVERED' },
      ],
      COURIER_DELIVERY: [
        { key: 'PROCESSING', label: 'PROCESSING' },
        { key: 'DISPATCHED', label: 'DISPATCHED' },
        { key: 'DELIVERED', label: 'DELIVERED' },
      ],
      STORE_PICKUP: [
        { key: 'PROCESSING', label: 'PROCESSING' },
        { key: 'PICKUP_READY', label: 'PICKUP READY' },
        { key: 'PICKED', label: 'PICKED' },
      ],
    },
    label: 'VoucherId',
    currentPage: queryParams.page - 1 || 0,
    pageSize: 25,
    searchPlaceholder: 'Voucher ID',
    searchId: 'id',
    searchKey: queryParams.searchKey || '',
    orderTypeKey:
      queryParams.deliveryType && queryParams.deliveryType !== 'ALL'
        ? queryParams.deliveryType
        : null,
    orderStatusKey:
      queryParams.deliveryStatus && queryParams.deliveryStatus !== 'ALL'
        ? queryParams.deliveryStatus
        : null,
    notFoundMessage: '',
    fetchError: '',
    loading: false,
    totalPages: 0,
    showDrawer: false,
    drawerData: null,
    isClearable: false,
    page: 1,
    validated: false,
    isSelected: false,
    selectAll: false,
    checkedRows: [],
    isloading: true,
    updateError: '',
    updateLoading: false,
    selectedPuchaseId: null,
    copied: false,
    showDatePickerModal: false,
    isCallApi: true,
    showOrderIdModal: false,
    orderTrackingId: '',
    searchCleared: false,
    orderTrackingIdError: '',
    trackingNotifyToUser: true,
    showPickerModal: false,
    isBookPrinting: false,
    showLabelModal: false,
    labelsToPrint: [],
  });

  const {
    tableHeading,
    orderData,
    loading,
    totalPages,
    currentPage,
    pageSize,
    showDrawer,
    drawerData,
    searchKey,
    isClearable,
    tabItems,
    orderTypeKey,
    orderStatusKey,
    fetchError,
    isSelected,
    selectAll,
    checkedRows,
    copied,
    showDatePickerModal,
    showPickerModal,
    isCallApi,
    isBookPrinting,
    searchCleared,
    showLabelModal,
    labelsToPrint,
  } = state;

  useEffect(() => {
      getOrderDetails(0);
      setQueryParam({
        [APP_PARAMS.PAGE]: queryParams.page || 1,
        [APP_PARAMS.DELIVERY_TYPE]: orderTypeKey ? orderTypeKey : 'ALL',
        [APP_PARAMS.DELIVERY_STATUS]: orderStatusKey ? orderStatusKey : 'ALL',
        [APP_PARAMS.SELECTED]: null,
      });

    //eslint-disable-next-line
  }, [orderTypeKey, orderStatusKey, searchCleared]);

  const getOrderDetails = async (currentPage) => {
    setState({ loading: true, orderData: [], fetchError: '' });
    try {
      const request = {
        filterKey:
          queryParams.deliveryType && queryParams.deliveryType !== 'ALL'
            ? queryParams.deliveryType
            : orderTypeKey,
        filterByStatus:
          queryParams.deliveryStatus && queryParams.deliveryStatus !== 'ALL'
            ? queryParams.deliveryStatus
            : orderStatusKey,
        searchKey: searchKey || queryParams.searchKey || '',
        page: currentPage || (queryParams.page ? queryParams.page - 1 : 0),
        size: pageSize,
      };
      const response = await getDeliveryOrders(request, props.auth.auth.token);

      setState({
        orderData: response.deliveryDetailsList,
        totalPages: response.total,
        currentPage: response.current,
      });

      if (queryParams.selected) {
        const rowData = response.deliveryDetailsList.find(
          (data) => data.purchaseId === queryParams.selected
        );

        setQueryParam({ [APP_PARAMS.SELECTED]: rowData.purchaseId });
        setState({
          drawerData: rowData,
          showDrawer: true,
        });
      }
    } catch (error) {
      setState({
        fetchError: 'Oops, something went wrong. Please try again',
      });
    }
    setState({ loading: false });
  };

  // Centralized function to handle all status updates
  const handleStatusUpdate = async ({
    status,
    deliveryTrackingId = null,
    trackingNotifyToUser = null,
    selectedDate = null,
    selectedTime = null,
    notifyToUser = null,
    skipModal = false,
    pickerName = null,
    pickerType = null,
    pickerPhoneNumber = null,
    notes = null,
  }) => {
    setState({ loading: true, updateLoading: true, fetchError: '' });
    try {
      const request = {
        purchaseId: drawerData.purchaseId,
        status,
        deliveryTrackingId,
        trackingNotifyToUser,
        selectedDate,
        selectedTime,
        notifyToUser,
        pickerName,
        pickerType,
        pickerPhoneNumber,
        notes,
      };
      const response = await updateStatus(request, props.auth.auth.token);
      if (response.message === 'DELIVERY_DETAILS_UPDATED_SUCCESSFULLY') {
        // Update orderData and drawerData based on status and tracking info
        setState((prevState) => ({
          ...prevState,
          orderData: prevState.orderData.map((order) =>
            order.purchaseId === drawerData.purchaseId
              ? {
                ...order,
                status,
                trackingId: deliveryTrackingId || order.trackingId,
              }
              : order
          ),
          drawerData: {
            ...prevState.drawerData,
            status,
            trackingId: deliveryTrackingId || prevState.drawerData.trackingId,
            pickUpDate: selectedDate || prevState.drawerData.pickUpDate,
            pickUpTime: selectedTime || prevState.drawerData.pickUpTime,
          },
          showOrderIdModal: false,
          updateLoading: false,
          notifyToUser: false,
          orderTrackingId: '',
          orderTrackingIdError: '',
          trackingNotifyToUser: false,
          showDrawer: status === 'PICKUP_READY' ? false : prevState.showDrawer,
        }));

        if (skipModal) {
          setState({ showOrderIdModal: false });
        }
        toast.success('Order status updated successfully');
      }
    } catch (error) {
      setState({
        updateError: 'Oops, something went wrong. Please try again',
        updateLoading: false,
        loading: false,
      });
      toast.error('Oops, something went wrong. Please try again');
    }
    setState({ updateLoading: false, loading: false });
  };

  // ---- Address Label Printing (Zebra via ZPL) ----
  const sanitizeZplText = (txt = '') =>
    String(txt)
      .replace(/[\^~]/g, ' ') // ZPL control chars
      .replace(/\s+/g, ' ')
      .trim();

  const formatAddress = (order) => {
    const parts = [
      order.houseAddress,
      order.landmarks,
      order.city,
    ].filter(Boolean);
    return sanitizeZplText(parts.join(', '));
  };

  const handlePrintDeliveryLabels = async (includeDeliveryNote) => {
    let device = null;

    try {
      if (!checkedRows.length) {
        toast.warning('Please select at least one order to print');
        return;
      }

      // FORCE printer popup (same as QR printing)
      device = await connectPrinter();
      const encoder = new TextEncoder();

      // Build ZPL: one sticker per selected order
      let zpl = '';

      checkedRows.forEach((purchaseId) => {
        const order = orderData.find((o) => o.purchaseId === purchaseId);

        if (!order) return;

        const receiver = sanitizeZplText(order.receiverName || 'N/A');
        const contact = sanitizeZplText(
          order.deliveryMobile || order.creatorMobile || 'N/A'
        );
        const address = formatAddress(order);

        const topField = receiver || 'N/A';
        const fontsize =
          topField.length <= 20 ? 34 :
            topField.length <= 30 ? 30 : 22;

        zpl += '^XA\n^CI28\n^PW609\n^LL812\n^LH0,0\n^MD22\n';

        let currentY = 25;
        const spacing = 12;

        zpl += `^FO30,${currentY}^A0N,${fontsize},${fontsize}^FB550,1,0,C^FD${topField}^FS\n`;
        currentY += fontsize + spacing;

        zpl += `^FO30,${currentY}^A0N,22,22^FB550,1,0,C^FD${contact}^FS\n`;
        currentY += 26;

        zpl += `^FO30,${currentY}^A0N,24,24^FB550,3,6,C^FD${address}^FS\n`;
        currentY += 60;

        if (includeDeliveryNote && order.deliveryNote) {
          const deliveryNote = sanitizeZplText(order.deliveryNote);
          zpl += `^FO30,${currentY}^A0N,20,20^FB550,2,8,C^FDDelivery Note: ${deliveryNote}^FS\n`;
        }

        zpl += '^XZ\n';
      });

      // Send to printer
      await device.transferOut(1, encoder.encode(zpl));

      toast.success('Delivery labels sent to printer successfully');

    } catch (err) {
      console.error('Zebra print (delivery labels) failed:', err);
      toast.error(err.message || 'Failed to print delivery labels');
    } finally {
      // Always clean up (same pattern as QR)
      if (device) {
        try {
          await device.releaseInterface(0);
        } catch (e) {
          toast.error("Failed to release device interface. Please try again.");
        }

        try {
          await device.close();
        } catch (e) {
          toast.error("Failed to close the device. Please try again.");
        }
      }
    }
  };


  const handleStatusChange = (key) => {
    switch (key) {
      case 'PICKUP_READY':
        setState({ showDatePickerModal: true });
        break;
      case 'DISPATCHED':
        setState((prevState) => ({
          ...prevState,
          showOrderIdModal: true,
          orderTrackingId: '',
          orderTrackingIdError: '',
        }));
        break;
      case 'PICKED':
        setState((prevState) => ({
          ...prevState,
          showPickerModal: true,
        }));
        break;
      default:
        handleStatusUpdate({ status: key });
    }
  };

  const handlePickerDetailsSave = async (pickerDetails) => {
    await handleStatusUpdate({
      status: 'PICKED',
      pickerName: pickerDetails.pickerName,
      pickerType: pickerDetails.type,
      pickerPhoneNumber: pickerDetails.pickerPhoneNumber,
      notes: pickerDetails.notes,
    });
    setState((prevState) => ({
      ...prevState,
      showPickerModal: false,
    }));
  };

  // Refactored DatePicker save handler
  const handleDatePickerSave = async (
    selectedDate,
    selectedTime,
    isMessageSent
  ) => {
    await handleStatusUpdate({
      status: 'PICKUP_READY',
      selectedDate,
      selectedTime,
      notifyToUser: isMessageSent,
    });
    setState({ showDatePickerModal: false });
  };

  const handleOrderTypeChange = (key) => {
    setQueryParam({
      [APP_PARAMS.PAGE]: 1,
      [APP_PARAMS.DELIVERY_TYPE]: key,
      [APP_PARAMS.SEARCH_KEY]: null,
    });
    setState({
      orderTypeKey: key,
      isClearable: false,
    });
  };

  const handleOrderStatusChange = (key) => {
    setQueryParam({
      [APP_PARAMS.PAGE]: 1,
      [APP_PARAMS.DELIVERY_STATUS]: key,
      [APP_PARAMS.SEARCH_KEY]: null,
    });
    setState({
      orderStatusKey: key,
      isClearable: false,
    });
  };

  const copyRedemptionId = (text) => {
    copyToClipboard(text);
    setState({
      copied: true,
    });
    setTimeout(() => {
      setState({
        copied: false,
      });
    }, 2000);
  };

  const handleSearch = () => {
    if (!isClearable || queryParams.searchKey) {
      const { searchKey } = state;
      if (searchKey !== queryParams.searchKey) {
        setState({ isCallApi: true });
      }
      if (searchKey || queryParams.searchKey) {
        setQueryParam({
          [APP_PARAMS.SEARCH_KEY]: searchKey || queryParams.searchKey,
          [APP_PARAMS.DELIVERY_STATUS]: orderStatusKey ? orderStatusKey : null,
          [APP_PARAMS.DELIVERY_TYPE]: orderTypeKey ? orderTypeKey : null,
        });
        setState({
          searchKey: searchKey || queryParams.searchKey,
          isClearable: true,
        });
        getOrderDetails(0);
      }
    } else {
      handleIdOnClear();
    }
  };

  const handleIdOnClear = () => {
    setQueryParam({
      [APP_PARAMS.SEARCH_KEY]: null,
      [APP_PARAMS.DELIVERY_STATUS]: orderStatusKey,
      [APP_PARAMS.DELIVERY_TYPE]: orderTypeKey,
    });
    setState({
      searchKey: '',
      isClearable: false,
      notFoundMessage: null,
      searchCleared: !state.searchCleared,
    });
  };

  const handleCheckBoxToggle = (rowId, event) => {
    event.stopPropagation();
    if (event.type !== 'change') return;
    handleCheck(rowId);
  };

  const handleCheck = (rowId) => {
    console.log('Toggling row ID:', rowId);
    setState((prev) => {
    const checkedSet = new Set(prev.checkedRows);
    let labels = [...prev.labelsToPrint];

    if (checkedSet.has(rowId)) {
      checkedSet.delete(rowId);
      labels = labels.filter((label) => label.purchaseId !== rowId);
    } else {
      checkedSet.add(rowId);
      const rowData = orderData.find((data) => data.purchaseId === rowId);
      if (rowData) {
        labels.push({
          id: rowData.voucherId,
          ownerName: rowData.ownerName,
          sender: rowData.sender,
          amount: rowData.voucherAmount,
          purchaseId: rowData.purchaseId,
        })
      }
    }

      return {
        ...prev,
        checkedRows: Array.from(checkedSet),
        labelsToPrint: labels,
      };
  })
  };

  const handleSelectAll = (event) => {
    setState({ selectAll: event.target.checked });
    if (event.target.checked) {
      const selectedAll = orderData.map((data) => data.purchaseId);
      const newLabels = orderData.map(
        ({ voucherId, ownerName, voucherAmount, sender, purchaseId }) => ({
          id: voucherId,
          ownerName,
          amount: voucherAmount,
          sender,
          purchaseId,
        })
      );
      setState({
        checkedRows: [...new Set([...checkedRows, ...selectedAll])],
        labelsToPrint: [...new Set([...labelsToPrint, ...newLabels])],
      });
    } else {
      const updatedCheckedRows = checkedRows.filter(
        (id) => !orderData.some((data) => data.purchaseId === id)
      );
      const updatedLabelsToPrint = labelsToPrint.filter(
        (label) => !orderData.some((data) => data.voucherId === label.id)
      );
      setState({
        checkedRows: updatedCheckedRows,
        labelsToPrint: updatedLabelsToPrint,
      });
    }
  };

  const searchOnChange = (value) => {
    setState({
      isCallApi: false,
      searchKey: value,
      orderTypeKey: orderTypeKey,
      orderStatusKey: orderStatusKey,
      isClearable: false,
    });
  };

  const handleOrderIdChange = (e) => {
    setState({
      orderTrackingId: e.target.value,
      orderTrackingIdError: '',
    });
  };

  const handleTrackingNotifyToUserChange = (e) => {
    setState({
      trackingNotifyToUser: e.target.checked,
    });
  };

  // Refactored Order Tracking ID Save
  const handleOrderTrackingIdSave = async () => {
    if (!state.orderTrackingId) {
      setState({ orderTrackingIdError: 'Order ID is required' });
      return;
    }
    await handleStatusUpdate({
      status: 'DISPATCHED',
      deliveryTrackingId: state.orderTrackingId,
      trackingNotifyToUser: state.trackingNotifyToUser,
    });
  };

  // Refactored Order Tracking ID Skip
  const handleOrderTrackingIdSkip = () => {
    setState({
      showOrderIdModal: false,
      trackingNotifyToUser: null,
      orderTrackingId: '',
      orderTrackingIdError: '',
    });
    handleStatusUpdate({ status: 'DISPATCHED', skipModal: true });
  };

  const renderOrderTrackingIdModal = () => (
    <Modal
      centered
      className={styles.orderIdModal}
      show={state.showOrderIdModal}
      onHide={() =>
        setState({ showOrderIdModal: false, trackingNotifyToUser: false })
      }
    >
      <Modal.Header closeButton>
        <Modal.Title>Enter Order Tracking ID</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          type='text'
          className='form-control'
          value={state.orderTrackingId}
          onChange={handleOrderIdChange}
          placeholder='Enter Tracking ID'
        />
        {state.orderTrackingIdError && (
          <div style={{ color: 'red', marginTop: 8 }}>
            {state.orderTrackingIdError}
          </div>
        )}
        <div style={{ marginTop: 16 }}>
          <input
            type='checkbox'
            id='trackingNotifyToUserCheckbox'
            checked={state.trackingNotifyToUser}
            onChange={handleTrackingNotifyToUserChange}
          />
          <label
            htmlFor='trackingNotifyToUserCheckbox'
            style={{ marginLeft: 8 }}
          >
            Send Notification to Customer
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button
          variant='secondary'
          onClick={() =>
            setState({ showOrderIdModal: false, trackingNotifyToUser: false })
          }
        >
          Cancel
        </Button> */}
        <Button variant='secondary' onClick={handleOrderTrackingIdSkip}>
          Skip
        </Button>
        <Button
          variant='primary'
          onClick={handleOrderTrackingIdSave}
          disabled={state.updateLoading}
        >
          {state.updateLoading ? 'Saving...' : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const renderDeeplinkColumn = (id) => {
    const url = `${process.env.REACT_APP_MERCHANT_PORTAL_URL}/vouchers/view-vouchers?page=1&searchId=id&searchKey=${id}`;
    return (
      <div
        onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
      >
        <span>🡕</span>
      </div>
    );
  };

  const renderFilterByType = () => {
    const { orderTypeKey, tabItems } = state;

    return (
      <Dropdown style={{ marginRight: '10px' }}>
        <Dropdown.Toggle variant='primary' id='dropdown-basic'>
          {tabItems.orderType.find((item) => item.key === orderTypeKey)?.label}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {tabItems.orderType.map((item) => {
            const { key, label } = item;
            return (
              <Dropdown.Item
                key={key}
                active={
                  key === (queryParams.deliveryType === 'ALL')
                    ? null
                    : queryParams.deliveryType
                }
                onClick={() => handleOrderTypeChange(key)}
              >
                {label}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const renderFilterByStatus = () => {
    const { tabItems, orderStatusKey } = state;

    return (
      <Dropdown>
        <Dropdown.Toggle variant='primary' id='dropdown-basic'>
          {
            tabItems.orderStatus.find((item) => item.key === orderStatusKey)
              ?.label
          }
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {tabItems.orderStatus.map((item) => {
            const { key, label } = item;
            return (
              <Dropdown.Item
                key={key}
                active={
                  key === (queryParams.deliveryType === 'ALL')
                    ? null
                    : queryParams.deliveryType
                }
                onClick={() => handleOrderStatusChange(key)}
              >
                {label}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const handleOrderPagination = (page) => {
    setQueryParam({ [APP_PARAMS.PAGE]: page + 1 });
    if (searchKey) {
      getOrderDetails(page);
    } else {
      getOrderDetails(page);
    }
    setState({
      currentPage: page,
    });
  };

  const handleOnClick = (id) => {
    const rowData = orderData.find((data) => data.purchaseId === id);
    setQueryParam({ [APP_PARAMS.SELECTED]: rowData.purchaseId });
    setState({
      showDrawer: true,
      drawerData: rowData,
    });
  };

  const handleDrawerOnHide = () => {
    setQueryParam({
      [APP_PARAMS.SELECTED]: null,
    });
    setState({
      showDrawer: !showDrawer,
      transactionDetails: [],
      showTransactions: false,
      selectedTransaction: null,
    });
  };

  const renderDrawer = () => {
    const data = drawerData;
    const generalDetails = [
      [
        { header: 'Voucher ID', value: data.voucherId },

        {
          header: 'Voucher Amount',
          value: `LKR ${data.voucherAmount
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
        },
      ],

      [
        { header: 'Receiver', value: data.receiverName },
        { header: 'Sender', value: data.sender },
      ],
      [
        {
          header: 'Creator Name (Thyaga Account Name)',
          value: data.creatorName,
        },
      ],
      [
        {
          header: data.deliveryMobile
            ? 'Delivery Mobile'
            : 'Creator/Picker Mobile',
          value: data.deliveryMobile ? data.deliveryMobile : data.creatorMobile,
        },
      ],
      [{ header: 'House Address', value: data.houseAddress }],
      [{ header: 'Landmark', value: data.landmarks }],
      [
        { header: 'City', value: data.city },
        { header: 'Order Status', value: 'orderStatus' },
      ],
      [
        {
          header: 'Add-ons',
          value: data.addons
            ? data.addons.map(({ name }) => {
              return (
                <>
                  {name}
                  <br />
                </>
              );
            })
            : '',
        },
      ],
      [
        {
          header: 'Delivery Charge',
          value:
            data.deliveryCharge != null
              ? `LKR ${data.deliveryCharge
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
              : 'NOT APPLICABLE',
        },
        {
          header: 'Addon Charges',
          value: data.addons
            ? `LKR ${data.addons
              .reduce((sum, obj) => sum + obj.price, 0)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
            : 'NOT APPLICABLE',
        },
      ],
      [{ header: 'Delivery Note', value: data.deliveryNote }],
      [{ header: 'Message', value: data.voucherMessage }],

      ...(data.pickUpDate &&
        data.pickUpTime &&
        data.physicalOption === 'STORE_PICKUP'
        ? [
          [
            { header: 'Pick Up Date', value: data.pickUpDate },
            { header: 'Pick Up Time', value: data.pickUpTime },
          ],
        ]
        : []),
      ...(data.trackingId &&
        data.trackingId !== null &&
        data.physicalOption === 'COURIER_DELIVERY'
        ? [
          [
            {
              header: 'Order Tracking ID',
              value: data.trackingId,
              conditionalRender: true,
            },
          ],
        ]
        : []),
    ];

    const renderDetails = (data) => {
      return (
        <>
          {data.map((row) => {
            if (row[0].conditionalRender && row[0].value === null) {
              return null;
            } else {
              return (
                <div key={row.id} className={styles.details__horizontal}>
                  {row.map((detailData, spanIndex) => (
                    <div
                      key={spanIndex}
                      className={styles.detail__group__nested}
                    >
                      <span className={styles.detail__header}>
                        {detailData.header}
                      </span>
                      {detailData.value === 'orderStatus' ? (
                        <DropdownButton
                          as={InputGroup.Prepend}
                          variant='secondary'
                          title={drawerData.status || 'N/A'}
                          id='input-group-dropdown-1'
                        >
                          {(tabItems?.[drawerData?.physicalOption] ?? []).map((item) => {
                            const { key, label } = item;
                            return (
                              <Dropdown.Item
                                key={key}
                                onClick={() => handleStatusChange(key)}
                              >
                                {label}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      ) : (
                        <span className={styles.detail__value}>
                          {detailData.value}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              );
            }
          })}

          {drawerData.pickUpReadySMS && (
            <div className={styles.pickup__ready__message}>
              <span className={styles.pickup__ready__message_header}>
                Sent Pickup Notification
                <OverlayTrigger
                  placement={'top'}
                  overlay={
                    <Tooltip>
                      {copied ? `Copied Message ✅` : `Click to copy Message`}
                    </Tooltip>
                  }
                >
                  <Button
                    onClick={() => copyRedemptionId(drawerData.pickUpReadySMS)}
                    variant='outline-dark'
                    size='sm'
                    className={styles.copy_icon}
                  >
                    <FontAwesomeIcon icon={faCopy} />
                  </Button>
                </OverlayTrigger>
              </span>
              <span
                className={styles.detail__value}
                dangerouslySetInnerHTML={{
                  __html: drawerData.pickUpReadySMS.replace('\n', '<br/><br/>'),
                }}
              />
            </div>
          )}
        </>
      );
    };

    return (
      <div className='purchase_drawer_root'>
        <div className='drawer_child'>
          <div className='header_group'>
            <div>
              <span className='header_title'>Purchase ID: </span>
              <span className='header_value'>
                {drawerData.purchaseId}
                <OverlayTrigger
                  placement={'top'}
                  overlay={
                    <Tooltip>
                      {copied
                        ? `Copied ${drawerData.purchaseId.toUpperCase()} ✅`
                        : `Click to copy ${drawerData.purchaseId.toUpperCase()}`}
                    </Tooltip>
                  }
                >
                  <Button
                    onClick={() =>
                      copyRedemptionId(drawerData.purchaseId.toUpperCase())
                    }
                    variant='outline-light'
                    size='sm'
                    className={styles.copy_icon}
                  >
                    <FontAwesomeIcon icon={faCopy} />
                  </Button>
                </OverlayTrigger>
              </span>
            </div>
            <div>
              <span className='header_title'>Mode: </span>
              <span className='header_value'>
                <strong>
                  {(() => {
                    const match = tabItems.orderType.find(
                      (s) => s.key === drawerData.physicalOption
                    );
                    return match && match.key !== null ? match.label : 'N/A';
                  })()}
                </strong>
              </span>
            </div>
          </div>
          <div className={styles.drawer__div}>
            <div className={styles.drawer__child}>
              {renderDetails(generalDetails)}
              {<div className={''} >
                <div className={styles.voucherThemeContainer}>
                  <div className={styles.imageWrapper}>
                    <span className={styles.detail__header}>
                      {'Voucher Theme'}
                    </span>
                    <img
                      className={styles.voucherThemeImage}
                      src={drawerData.voucherFront}
                      alt='Voucher theme'
                    />
                  </div>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const printCarrierBook = async (amount, to, from, body) => {
    setState({ isBookPrinting: true });
    try {

      const selectedData = getVoucherIdsForCheckedRows();
      const selected = selectedData.map((item) => {

        return { voucherId: item.voucherId, amount, to, from, body };
      });

      const request = [...selected];

      const token = props.auth.auth.token;
      const carrierBookResponse = await getCarrierBook(request, token);

      const decodedPdfData = Buffer.from(carrierBookResponse, 'base64');
      const blob = new Blob([decodedPdfData], { type: 'application/pdf' });
      const date = new Date();
      const fileName =
        'Carrier_Board_' + formatDateTime(date, DATE_TIME_TYPES.ISO_DATE_TIME);
      FileSaver.saveAs(blob, fileName);
    } catch (error) {
      console.error('Error printing carrier book:', error);
    } finally {
      setState({ isBookPrinting: false });
    }
  };

  const handlePrintCodes = async () => {
    const SHEET_SIZE = 3;      // 3 QR codes per sheet
    let index = 0;
    let printedCount = 0;
    let device = null;

    try {
      device = await connectPrinter();
      const encoder = new TextEncoder();

      while (index < checkedRows.length) {
        // Send ONE sheet at a time with entire lifecycle
        let zpl = "^XA\n^MD22\n^PW799\n^LL799\n";

        for (let pos = 0; pos < SHEET_SIZE && index < checkedRows.length; pos++) {
          const selectedData = getVoucherIdsForCheckedRows();
          const id = selectedData[index].voucherId;
          const positionX = pos === 0 ? 38 : pos === 1 ? 302 : 566;
          const textX = pos === 0 ? 70 : pos === 1 ? 334 : 600;

          zpl += `^FO${positionX},6^BQN,2,6^FDQA,https://thyaga.lk/checkbalance/${id}^FS\n`;
          zpl += `^FO${textX},220^A0N,28,28^FD${id}^FS\n`;

          index++;
          printedCount++;
        }

        zpl += "^XZ\n";

        // Send and wait for physical print
        try {
          await device.transferOut(1, encoder.encode(zpl));

        } catch (e) {
          toast.error(`Failed to print QR for voucher ID: ${checkedRows[index - 1]}`);
          throw e;
        }

        // CRITICAL: Wait for printer to physically eject sheet before next command
        // Increase this if sheets are jamming or overlapping
        await new Promise(resolve => setTimeout(resolve, 800));
      }

      toast.message(`All ${printedCount} QRs printed successfully`);
      await new Promise(resolve => setTimeout(resolve, 1000));

    } catch (error) {
      toast.error(`Print failed: ${error.message}`);
    } finally {
      if (device) {
        try {
          await device.releaseInterface(0);
        } catch (e) { }
        try {
          await device.close();
        } catch (e) { }
      }
    }
  };

  const printPdf = async () => {
    try {
      const request = { voucherIds: getVoucherIdsForCheckedRows().map(item => item.voucherId) };
      const token = props.auth.auth.token;
      const rawPdfResponse = await getQrPdf(request, token);
      generateAndSavePdf(rawPdfResponse);
    } catch (error) {
      console.error('Error printing PDF:', error);
    }
  };

  const handleShowLabelModal = () => {
    setState({ showLabelModal: !showLabelModal });
  };

  const getVoucherIdsForCheckedRows = () => {
    return orderData
      .filter(order => checkedRows.includes(order.purchaseId))
      .map(order => ({
        voucherId: order.voucherId,
      }));
  }

  const handleMultipleCheck = (ids) => {
    setState((prev) => {
      const checkedSet = new Set(prev.checkedRows);
      let labels = [...prev.labelsToPrint];

      ids.forEach((id) => {
        if (checkedSet.has(id)) {
          checkedSet.delete(id);
          labels = labels.filter((lbl) => lbl.id !== id);
        } else {
          checkedSet.add(id);
          const rowData = orderData.find((v) => v.purchaseId === id);
          if (rowData) {
            labels.push({
              id: rowData.voucherId,
              ownerName: rowData.ownerName,
              sender: rowData.sender,
              amount: rowData.voucherAmount,
              purchaseId: rowData.purchaseId,
            });
          }
        }
      });

      return {
        ...prev,
        checkedRows: Array.from(checkedSet),
        labelsToPrint: labels,
      };
    });
  };

  return (
    <div className={styles.root_div}>
      <div>
        <PageHeader text='Deliveries & Pickups' />
        <div className={styles.filter_block_status}>
          <span>Filter by Type & Order Status </span>
          <div className='d-flex my-3'>
            {renderFilterByType()}
            {renderFilterByStatus()}
          </div>
        </div>
        <div className={styles.search_area_block}>
          <div className={styles.search_area}>
            <Search
              placeholder={'Enter Puchase or Voucher ID'}
              onBtnPress={handleSearch}
              onClearPress={handleIdOnClear}
              onChange={searchOnChange}
              max={50}
              handleValueFromParent
              value={searchKey}
              searchKey={queryParams.searchKey}
            />
          </div>
        </div>
        <div className={styles.print_button_block}>
          <div className='mb-3 d-flex align-items-end'>
            {checkedRows.length > 0 && (
              <>
                <span style={{ lineHeight: '24px' }}>
                  {checkedRows.length} order
                  {checkedRows.length > 1 ? 's' : ''} selected
                </span>
                <span>
                  <CloseButton
                    className='ml-2'
                    onClick={() => {
                      setState({ checkedRows: [], selectAll: false, labelsToPrint: [] });
                    }}
                  />
                </span>
              </>
            )}
          </div>
          <div className='d-flex gap-2 my-3'>
            <Button
              variant='primary'
              disabled={checkedRows.length === 0}
              onClick={() => setState(prev => ({ ...prev, showDeliveryModal: true }))}
            >
              Print Delivery Sticker
            </Button>
            <Dropdown>
              <Dropdown.Toggle
                disabled={checkedRows.length === 0}
                variant='success'
                id='dropdown-basic'
              >
                Print Book
                {isBookPrinting && <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => printCarrierBook(true, true, true, true)}
                >
                  With Sender & Receiver
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => printCarrierBook(true, false, true, true)}
                >
                  With Sender Only
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => printCarrierBook(true, true, false, true)}
                >
                  With Receiver Only
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => printCarrierBook(true, false, false, true)}
                >
                  Message Only
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => printCarrierBook(true, false, false, false)}
                >
                  Amount Only
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown>
              <Dropdown.Toggle
                disabled={checkedRows.length === 0}
                variant='primary'
                id='dropdown-basic'
              >
                Print QR Codes
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handlePrintCodes()}>
                  Print with Zebra
                </Dropdown.Item>
                <Dropdown.Item onClick={() => printPdf()}>
                  Download PDF
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Button
              variant='secondary'
              onClick={() => handleShowLabelModal()}
              disabled={labelsToPrint.length < 1}
            >
              Print Labels
            </Button>
          </div>
        </div>

        <div>
          <CheckableDataTable
            tableData={orderData}
            tableheading={tableHeading}
            isSelected={isSelected}
            tag='orders'
            fetchError={fetchError}
            notFoundMessage={fetchError}
            search_filter_loading={loading}
            searchFilterLoading={false}
            handleOnClick={handleOnClick}
            handleCheck={handleCheckBoxToggle}
            handleSelectAll={handleSelectAll}
            handleMultipleCheck={handleMultipleCheck}
            checkedRows={checkedRows}
            selectAll={selectAll}
            renderDeeplinkColumn={renderDeeplinkColumn}
          />
          {!loading && !fetchError && (
            <Pagination
              pageCount={totalPages}
              onChange={handleOrderPagination}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
      <Drawer show={showDrawer} onHide={handleDrawerOnHide} backdrop={true}>
        {drawerData && renderDrawer()}
      </Drawer>

      {renderOrderTrackingIdModal()}
      <DatePickerModal
        show={showDatePickerModal}
        onClose={() => setState({ showDatePickerModal: false })}
        onSave={handleDatePickerSave}
      />
      <PickerDetailsGetModal
        show={showPickerModal}
        onClose={() => setState((prevState) => ({ ...prevState, showPickerModal: false }))}
        onSubmit={handlePickerDetailsSave}
        loading={loading}
      />
      <DeliveryDetailsPrintModal
        show={state.showDeliveryModal}
        onHide={() => setState(prev => ({ ...prev, showDeliveryModal: false }))}
        selectedOrders={orderData.filter(order => checkedRows.includes(order.purchaseId))}
        onPrintWithZebra={(notes) => handlePrintDeliveryLabels(notes)}
      />
      <NameLabelModal
        show={showLabelModal}
        labelsToPrint={labelsToPrint}
        handleClose={handleShowLabelModal}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(ViewOrders);


